import { createSaasPaymentSetups } from '@lib/axios/pg'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useCreate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Menambah PG')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    (data) => createSaasPaymentSetups(data.secret_api_key, data.verification_token),
    {
      onSuccess: () => queryClient.invalidateQueries('saas-pg'),
    }
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
    },
  })
}

export default useCreate
